import IdeyaModal from '../../../../../common/antd/ideya-modal.tsx'
import IdeyaTypography from '../../../../../common/antd/ideya-typography.tsx'
import { useDeleteBlockLeaveMutation } from '../../../../../apis/block-leave/block-leave-api.api.ts'
import { IdeyaSpinner } from '../../../../../common/components/ideya-spinner.tsx'
import { useTranslation } from 'react-i18next'

interface UserWithdrawBlockLeaveModalProps {
  blockLeaveId: string | null
  showWithdrawBlockLeaveModal: boolean
  handleCancel: () => void
}

export const UserWithdrawBlockLeaveModal: React.FC<
  UserWithdrawBlockLeaveModalProps
> = ({ blockLeaveId, showWithdrawBlockLeaveModal, handleCancel }) => {
  const { t } = useTranslation()
  const [deleteBlockLeave, { isLoading }] = useDeleteBlockLeaveMutation()

  const onFinish = async () => {
    await deleteBlockLeave({ id: blockLeaveId ?? '' })
    handleCancel()
  }

  return (
    <IdeyaModal
      open={showWithdrawBlockLeaveModal}
      title={t(
        'user_management.user_modal.block_leave_modal.withdraw_leave_dates'
      )}
      onOk={onFinish}
      onCancel={handleCancel}
    >
      {isLoading ? (
        <IdeyaSpinner />
      ) : (
        <IdeyaTypography.Text>
          {t(
            'user_management.user_modal.block_leave_modal.are_you_sure_withdraw'
          )}
        </IdeyaTypography.Text>
      )}
    </IdeyaModal>
  )
}
